<app-page-header [heading]="'Payment'" [icon]="'fa-money-bill-alt'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
    <div class="row">
        <div class="form-group col-lg-3">
            <label>Payment No</label><span class="text-danger">&nbsp;*</span>
            <input type="text" [(ngModel)]="payment.payment_no" [readonly]="true" class="form-control" >
        </div>
                <div class="form-group col-lg-3">
            <label>Date</label><span class="text-danger">&nbsp;*</span>
            <input (ngModelChange)="payment.payment_date = $event" [max]="getToday()"
             [ngModel]="payment.payment_date | date:'yyyy-MM-dd' "
             class="form-control" id="date" name="date" type="date">
        </div>
        <div class="form-group col-lg-3">
            <label>Supplier Name</label><span class="text-danger">&nbsp;*</span>
            <ngx-select-dropdown (change)="getVendor($event);" [(ngModel)]="payment.vendor_data"
                                [config]="utils.dropConfig({displayKey: 'VENDOR_NAME',placeholder: 'Select supplier',searchOnKey: 'VENDOR_NAME'})"
                                [multiple]="false" [options]="vendor_options" class="form-control select-dropdown" name="vendor_data"></ngx-select-dropdown>
        </div>
        <div class="form-group col-lg-3">
            <label>Payment Type</label>
            <div class="col-12">
                <label class="checkbox-inline">
                    <input (click)="selectPaymentType('Cash')" [checked]="payment.payment_type == 'Cash'" id="cash"
                        name="payment_type" type="radio"
                        value="Cash">&nbsp;&nbsp;Cash
                </label>&nbsp;&nbsp;
                <label class="checkbox-inline">
                    <input (click)="selectPaymentType('Bank')" [checked]="payment.payment_type == 'Bank'" id="Bank"
                            name="payment_type" type="radio"
                            value="Bank">&nbsp;&nbsp;Bank
                </label>&nbsp;&nbsp;
                <label class="checkbox-inline">
                <input (click)="selectPaymentType('UPI')" [checked]="payment.payment_type == 'UPI'" id="UPI"
                        name="payment_type" type="radio"
                        value="UPI">&nbsp;&nbsp;UPI
                </label>&nbsp;&nbsp;
                <label class="checkbox-inline">
                <input (click)="selectPaymentType('Cheque')" [checked]="payment.payment_type == 'Cheque'" id="cheque"
                        name="payment_type" type="radio"
                        value="Cheque">&nbsp;&nbsp;Cheque
                </label>&nbsp;&nbsp;
                <label class="checkbox-inline">
                <input (click)="selectPaymentType('Card')" [checked]="payment.payment_type == 'Card'" id="Card"
                        name="payment_type" type="radio"
                        value="Card">&nbsp;&nbsp;Card
                </label>&nbsp;&nbsp;
            </div>
        </div>
        <div class="form-group col-lg-3">
            <label>Amount</label><span class="text-danger">&nbsp;*</span>
            <input type="text" maxlength="20" [(ngModel)]="payment.payment_amount" class="form-control" placeholder="Enter amount"
            (keypress)="numberOnly($event)" (blur)="autoDistributeAmount()" name="payment.payment_amount" (keyup.enter)="autoDistributeAmount()">
        </div>
    </div>

    <div *ngIf="invoices_list.length > 0" class="mt-4">
        <h4 class="list-header mb-3"><i class="fas fa-file-invoice"></i> Supplier Invoices</h4>
        <table class="table table-bordered table-striped">
            <thead>
            <tr>
                <th>#</th>
                <th>Invoice No</th>
                <th>Date</th>
                <th class="text-right">Adjusted Amount</th>
                <th class="text-right">Invoice Amount</th>
                <th class="text-right">Adjust Amount</th>
                <th class="text-right">Balance Amount</th>
                <th class="text-center">Select</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let inv of invoices_list; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ inv.INVOICE_NUMBER }}</td>
                <td>{{ inv.INVOICE_DATE | date:'dd-MM-yyyy' }}</td>
                <td class="text-right">{{ inv.ADJUSTED_AMOUNT | number:'1.2-2' }}</td>
                <td class="text-right">{{ inv.NET_TOTAL | number:'1.2-2' }}</td>
                <td class="text-right">
                    <input type="number" [(ngModel)]="inv.adjust_amount" class="form-control text-right" [readonly]="!inv.checked" (input)="recalculateTotal()" />
                </td>
                <td class="text-right">{{ ((inv.NET_TOTAL - inv.ADJUSTED_AMOUNT ) - (inv.adjust_amount || 0)) | number:'1.2-2' }}</td>
                <td class="text-center">
                    <input type="checkbox" [(ngModel)]="inv.checked" (change)="recalculateTotal()" />
                </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <td colspan="5" class="text-right"><strong>Total Adjusted:</strong></td>
                <td class="text-right"><strong>{{ total_adjusted | number:'1.2-2' }}</strong></td>
                <td class="text-right"><strong>{{ getTotalBalance() | number:'1.2-2' }}</strong></td>
                <td></td>
            </tr>
            </tfoot>
        </table>
    </div>

    <div class="clearfix"></div>
    <div class="row container">
        <div class="col-lg-12 pull-right">
            <button (click)="savePayment();" *ngIf="user_rights.ADD == '1'" class="btn btn-info btn-sm ng-star-inserted"
                    type="button">  {{ payment.edit_status ? 'Update' : 'Save' }}
            </button>&nbsp;&nbsp;&nbsp;
            <button (click)="clear();" *ngIf="user_rights.ADD == '1'" class="btn btn-warning btn-sm ng-star-inserted"
                    type="button">  Cancel
            </button>&nbsp;&nbsp;&nbsp;
        </div>
    </div>

    <div class="mt-5 mb-5">
        <h4 class="list-header mb-3"><i class="fas fa-list"></i> Payment List</h4>
        <table class="table tbl  table-hover table-striped  table-bordered">
            <thead>
                <tr>
                    <th>#</th>
                    <th class="text-left">Payment No</th>
                    <th class="text-left">Date</th>
                    <th class="text-left">Supplier Name</th>
                    <th class="text-left">Payment Type</th>
                    <th class="text-right">Amount</th>
                    <th class="text-center">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of payment_list;let i=index">
                    <td>{{ i+1 }}</td>
                    <td>{{ data.PAYMENT_NO }}</td>
                    <td>{{ data.FORMATED_DATE }}</td>
                    <td>{{ data.VENDOR_NAME }}</td>
                    <td>{{ data.PAYMENT_TYPE }}</td>
                    <td class="text-right">{{ data.PAYMENT_AMOUNT }}</td>
                    <td class="text-center">
<!--                       <button (click)="edit_payment(data)" class="btn btn-success btn-sm mb-2" title="Edit data" type="button">-->
<!--                            <i class="fa fa-edit" style="color: white;"></i></button>&nbsp;&nbsp;-->
                        <button (click)="delete_payment(data.PAYMENT_ID)" class="btn btn-danger btn-sm mb-2" title="Delete data" type="button">
                            <i class="fa fa-trash" style="color: white;"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
